
const CartDiscountAllocation = {
  "name": "CartDiscountAllocation",
  "kind": "INTERFACE",
  "fieldBaseTypes": {
    "discountedAmount": "MoneyV2"
  },
  "possibleTypes": ["CartAutomaticDiscountAllocation", "CartCodeDiscountAllocation", "CartCustomDiscountAllocation"]
};
export default CartDiscountAllocation;